(function(window, $) { 'use strict';

    var _cache = $.extend({}, {

    }, window.cache);

    function Carousels() {
        this.utilities = new window.Utilities();
        this.clamp = new window.Clamp();
    }

    Carousels.prototype.init = function( $selector ) {

        var self = this;

        $selector = $selector || $('.owl-carousel');

        // carousels
        $selector.each(function() {

            var $carousel = $(this),
                settings = $carousel.data('owl-settings'),
                itemsLength = $carousel.find('li').length,
                arrowLeftClass = ( $carousel.hasClass('owl-invert') ) ? 'arrow-left-invert': 'arrow-left',
                arrowRightClass = ( $carousel.hasClass('owl-invert') ) ? 'arrow-right-invert': 'arrow-right';

            // destroy carousel plugin if already exists
            if( $carousel.data('owl.carousel') ) {
                // $carousel.data('owl.carousel').destroy();
                $carousel.data('owl.carousel').trigger('refresh.owl.carousel');
            } else if( itemsLength > 0 ) {

                $carousel.owlCarousel({
                    margin: settings.margin,
                    itemsDesktop: false,
                    responsiveRefreshRate: 50,
                    items: Math.min(settings.items, itemsLength),
                    lazyLoad: settings.lazyLoad,
                    nav: ( itemsLength > 1 ) ? settings.navigation : false,
                    center: settings.center,
                    // URLhashListener: settings.hash,
                    navText: [
                        '<i class="owl-arrow-left icon ' + arrowLeftClass + '"></i>',
                        '<i class="owl-arrow-right icon ' + arrowRightClass + '"></i>'
                    ],
                    dots: settings.dots,
                    responsive: settings.responsive,
                    singleItem: settings.singleItem,
                    // startPosition: 'URLHash',
                    loop: ( itemsLength > 1 && settings.loop !== false ) ? true : false,
                    video: false, // true,
                    onResize: function( data ) {
                        // console.log('carousel on resize data', data, $carousel, settings);

                        window.setTimeout(function() {

                            if( settings.maxViewportWidth !== undefined ) {
                                if( $(window).width() < settings.maxViewportWidth ) { // if mobile media query
                                    $carousel.removeClass('off');
                                } else {
                                    $carousel.addClass('off');
                                }

                                self.clamp.init( $carousel.find('[data-clamp]') );

                                $carousel.trigger('initialized.owl.carousel');
                            }

                        }, 0);
                    },
                    onResized: function() {

                        if( $carousel.closest('.isotope').length > 0 ) {

                            window.setTimeout(function() {

                                if( $carousel.data('isotope') ) {
                                    $carousel.css({ 'min-height' : $carousel.height() });
                                    $carousel.isotope('destroy');
                                }

                                $carousel.isotope({
                                    itemSelector: '.owl-item:not(.cloned)',
                                    layoutMode: 'masonry',
                                    percentPosition: true,
                                    resize: false,
                                    transitionDuration: 0
                                });

                                $carousel.css({ 'min-height' : 0 });


                            }, 0);

                        }
                    },
                    onLoadLazy: function( event ) {
                        if( this.settings.lazyLoad ) {
                            $(event.element).closest('.owl-item').addClass('loading');
                            $(event.element).closest('.owl-carousel-item').removeClass('hidden');
                        }
                    },
                    onLoadedLazy: function( event ) {
                        if( this.settings.lazyLoad ) {
                            $(event.element).closest('.owl-item').removeClass('loading').addClass('loaded');
                        }
                    },
                    onChanged: function( event ) {
                        if( settings.hash && event.property.name === 'position' ) {
                            var currentPage = Math.max(event.page.index, 0),
                                targetHash = $(event.target).find('.owl-item').not('.cloned').find('[data-hash]').eq(currentPage).data('hash');

                            if( targetHash ) {
                                window.location.hash = targetHash;
                            } else {
                                window.location.hash = '/';
                            }
                        }
                    },
                    onInitialized: function( event ) {
                        if( settings.hash ) {
                            window.setTimeout(function() {
                                var currentPage = Math.max($(event.target).find('.owl-item').not('.cloned').find('[data-hash]').index($(event.target).find('.owl-item').not('.cloned').find('[data-hash="' + window.location.hash.replace('#', '') + '"]')), 0);
                                $carousel.trigger('to.owl.carousel', [ currentPage, 0 ]);
                            }, 0);
                        }

                        // trigger resize to
                        window.setTimeout(function() {
                            $carousel.data('owl.carousel')._width = 0;
                            $carousel.data('owl.carousel').onResize();
                        }, 0);
                    }

                });

            }

        });

    };

    Carousels.prototype.add = function( $carousel, items ) {

        for(var i = 0, length = items.length; i < length; i++) {
            $carousel.trigger('add.owl.carousel', [ items[i] ]);
        }

        window.setTimeout(function() {
            $carousel.data('owl.carousel')._width = 0;
            $carousel.data('owl.carousel').onResize();
        }, 0);

    };

    Carousels.prototype.eventHandlers = {

        onResize: function() {

        },

        onResized: function() {

        },

        onLoadLazy: function() {

        },

        onLoadedLazy: function() {

        },

        onChanged: function() {

        },

        onInitialized: function() {

        }

    };

    window.Carousels = Carousels;

})(window, jQuery);
